// extracted by mini-css-extract-plugin
export default {"header":"Header_header__nOZ0+","menuContainer":"Header_menuContainer__e7X5T"};